import { RequestPart } from '@/app/system/request/RequestPart';
import { Guest } from '@/app/system/guest/Guest';
import { RequestDocument } from '@/app/system/request/RequestDocument';
import { GuestDynamic } from '@/app/system/guest/GuestDynamic';

export class SupportList implements RequestPart {
  public constructor(private baseRequest: RequestPart) {}

  request(guest: Guest<RequestDocument>): this {
    this.baseRequest.request(new GuestDynamic((request: RequestDocument, options) => {
      request.url = '/api/technicalSupport';
      request.method = 'get';
      guest.receive(request, options);
    }));
    return this;
  }
}
